// extracted by mini-css-extract-plugin
module.exports = {"discount":"ValuesAndDiscounts_discount__XCvH9","chart":"ValuesAndDiscounts_chart__t2lAV"};